import ResponsiveImage from '@/components/responsive-image';

export default function Announcement({album}) {
    const {
        title,
        artists,
        cover,
        offers,
    } = album

    return (
        <AlbumWrapper>
            <AlbumImage>
                {cover != null && (
                    <div className='w-full md:max-w-2/3'>
                        <ResponsiveImage
                            fetchPriority='high'
                            className="object-contain rounded-lg border border-muted shadow-md"
                            srcSet={cover.srcset}
                            height={cover.width}
                            width={cover.height}
                            alt={`${title} Album Cover`}
                        />
                    </div>
                )}
            </AlbumImage>
            <AlbumInfo>
                <span className="text-2xl uppercase">{title}</span>
                {offers && (
                    <a
                        href={offers && offers[0].url}
                        className='text-lg hover:bg-primary hover:text-secondary underline px-1.5'
                        target='_blank'
                        rel='noopener noreferrer'
                    >Buy album</a>
                )}
            </AlbumInfo>
            <div className="flex flex-col space-y-20 md:max-lg:col-span-2 lg:col-start-2">
                <div className='space-y-2'>
                    {artists.filter(artist => artist.pivot.role === 'band').map((artist, idx) => (
                        <AlbumArtist key={idx} {...artist} />
                    ))}
                </div>
            </div>
            <p className='md:max-lg:col-span-2 lg:col-start-3'>
                Recorded and mixed by <span className="font-medium">Bjarne Stensli</span>
                <br />
                Cover design by <span className="font-medium">Nina Birkeland</span>
                <br />
                Mastered by <span className="font-medium">George Tanderø</span>
                <br />
                Guest performances by <span className="font-medium">Mira Thiruchelvam</span> and <span className="font-medium">Sara Övinge</span>

            </p>
        </AlbumWrapper>
    )
}


const AlbumWrapper = ({children}) => {
    return (
        <div className='grid grid-cols-1 md:grid-cols-4 p-8 gap-4'>
        {children}
        </div>
    )
}

const AlbumImage = ({children}) => {
    return (
        <div className='flex px-12 py-4 justify-center items-center animate-in-out duration-150 w-full md:col-span-4'>
            {children}
        </div>
    )
}

const AlbumInfo = ({children}) => {
    return (
        <div className="flex flex-col items-center space-y-1 md:col-span-4">
            {children}
        </div>
    )
}

const AlbumArtist = ({name, pivot}) => {
    return (
        <div className='flex items-center gap-2'>
            <span className="font-medium">{name}</span>
            <span className="text-muted flex-1 truncate">{pivot.description}</span>
        </div>
    )
}
